import { Component } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import _ from 'lodash';
import { ToastPackage, ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AcceptRingingCallAction, EndCallAction } from 'src/app/store/samwin/client-phone/client-phone.actions';
import { ClientPhoneState } from 'src/app/store/samwin/client-phone/client-phone.state';
import { SamwinCallListState } from 'src/app/store/samwin/samwin-call-list/samwin-call-list.state';
import { SamwinLinesStateSelector } from 'src/app/store/samwin/samwin-lines/samwin-lines.selector';
import { SamwinSkillsState } from 'src/app/store/samwin/samwin-skills/samwin-skills.state';
import { SkillGroup } from 'src/app/store/samwin/samwin-skills/skill-group';
import { flyInOut } from '../../utility/animation/animations';
import { CallingToastBaseComponent } from '../calling-toast-base/calling-toast.base.component';

@Component({
   selector: 'samweb-ringing-toast',
   templateUrl: './ringing-toast.component.html',
   styleUrls: ['./ringing-toast.component.scss'],
   animations: [flyInOut],
})
export class RingingToastComponent extends CallingToastBaseComponent {
   public skillGroup$: Observable<SkillGroup>;

   @Select(ClientPhoneState.isCallRingingAndAcceptable)
   public isCallRingingAndAcceptable$: Observable<boolean>;

   @Select(SamwinLinesStateSelector.canDisconnectLineA)
   public canDisconnectLineA$: Observable<boolean>;

   constructor(toastrService: ToastrService, toastPackage: ToastPackage, store: Store) {
      super(toastrService, toastPackage, store);
      this.skillGroup$ = this.currentCallShortInfo$.pipe(
         map((callinfo) => {
            if (_.isNil(callinfo)) {
               return null;
            }
            const skillId = store.selectSnapshot(SamwinCallListState.getCallByIdFn)(callinfo.callId).queueId;
            const skill = store.selectSnapshot(SamwinSkillsState.getSkill(skillId));
            return !_.isNil(skill) ? new SkillGroup([skill]) : null;
         })
      );
   }

   declineCall() {
      this.toastrService.clear(this.toastPackage.toastId);
      this.store.dispatch(new EndCallAction());
   }

   acceptCall() {
      this.toastrService.clear(this.toastPackage.toastId);
      this.store.dispatch(new AcceptRingingCallAction());
   }
}
